module.exports = __webpack_public_path__ + "static/media/blueTheme.53f1e92c.jpg";